<template>
  <div class="role-manage">
    <div class="role-list">
      <Menu ref="menu" :active-name="diyData.activeName" @on-select="menuChange">
        <Button type="primary" style="width: 100%;margin-bottom:10px;" icon="ios-add" @click="addRole">添加角色</Button>
        <MenuItem v-for="(item, index) in apiData.roleList" :key="index" :name="index">{{ item.name }}</MenuItem>
      </Menu>
    </div>
    <div class="form">
      <Form ref="addForm" :model="form" :rules="diyData.rules" :label-width="100">
        <FormItem label="角色名称" prop="name">
          <Input v-model="form.name" placeholder="请输入角色名称" style="width: 400px"></Input>
          <a style="color:#2d8cf0;margin-left:10px" v-if="diyData.activeName !== ''" @click="deleteRole">删除角色</a>
        </FormItem>
        <FormItem label="功能权限" prop="permission">
          <div class="permission-wrap">
            <Alert show-icon>决定用户可以看到哪些页面和哪些操作</Alert>
            <div class="permission-content">
              <div class="item" v-for="(item, index) in apiData.permissionList" :key="index">
                <Tree :ref="`ref${index}`" :data="[item]"  show-checkbox></Tree>
              </div>
            </div>
          </div>
        </FormItem>
        <FormItem>
          <Button type="primary" style="width: 90px; margin-right: 20px" @click="submit">保存</Button>
        </FormItem>
      </Form>
    </div>
  </div>
</template>

<script>
  import * as apiRole from '@/api/permission/role'
  import * as apiStaff from '@/api/permission/admin'
  export default {
    name: 'role-manage',
    data() {
      return {
        query: {},
        search: {},
        diyDom: {
          isEdit: false, // 是否是编辑
        },
        // 表单数据
        form: {
          name: '',
          permission: [],
        },
        diyData: {
          id: '', // 某条数据的id
          activeName: 0, // 默认选择第0个
          rules: {
            name: [
              {
                required: true,
                message: '角色名不能为空',
                trigger: 'blur',
              },
            ],
          },
        },
        apiData: {
          roleList: [], // 角色数组
          permissionList: [], // 权限列表，回显
        },
      }
    },
    methods: {
      // 获取所有的权限
      getPermission(type = 'init') {
        return new Promise(resolve => {
          apiStaff.apiGetPermission().then(res => {
            this.apiData.permissionList = res.data.map(item => {
              return {
                ...item,
                value: [],
              }
            })
            if (type == 'init') {
              this.getRoleList()
            }
            resolve()
          })
        })
      },
      // 获取角色列表
      getRoleList() {
        this.$store.commit('setSpinShow', true)
        apiRole
          .apiRoleList()
          .then(res => {
            this.apiData.roleList = res.data
            if (res.data.length > 0) {
              this.getDetail(res.data[0].id)
              this.$nextTick(() => {
                this.diyData.activeName = 0
                this.$refs.menu.updateActiveName()
              })
            }
          })
          .finally(() => this.$store.commit('setSpinShow', false))
      },
      // 获取角色详情
      getDetail(id) {
        this.diyDom.isEdit = true
        this.diyData.id = id
        apiRole
          .apiRoleDetail(id)
          .then(res => {
            this.form.name = res.data.name
            this.form.permission = res.data.permissions
            // 回填树
            this.selectAuth(this.form.permission, this.apiData.permissionList)
          })
          .finally(() => this.$store.commit('setSpinShow', false))
      },
      // 删除角色
      deleteRole() {
        this.$Modal.confirm({
          title:'提示',
          content:'请确认是否删除当前角色？',
          onOk:() =>{
            apiRole.apiRoleDelete(this.diyData.id).then(() => {
              this.$Message.success('删除成功')
              this.getRoleList()
            })
          }
        })
      },
      // 切换角色
      menuChange(e) {
        this.diyData.activeName = e
        this.$store.commit('setSpinShow', true)
        // 切换角色的时候，需要将权限的默认值全部清空
        this.getPermission('change').then(res => {
          this.getDetail(this.apiData.roleList[e].id)
        })
      },
      // 添加角色
      addRole() {
        this.diyData.activeName = ''
        this.diyDom.isEdit = false
        this.diyData.id = ''
        this.$refs['addForm'].resetFields()
        this.form.permission = []
        this.getPermission('change')
      },

      // 回填树选中项
      selectAuth(menus, arr) {
        menus.forEach(item => {
          arr.forEach((citem, cindex) => {
            if (citem.id == item) {
              this.$set(arr[cindex], 'checked', true)
            }
            if (citem.children && citem.children.length > 0) {
              // 如果存在子菜单，把父菜单选择为空，不然会全部选择上，在提交的时候，用数组去重
              this.$set(arr[cindex], 'checked', false)
              this.selectAuth(menus, citem.children)
            }
          })
        })
      },
      submit() {
        // 获取树id权限集合
        this.form.permission = []
        this.apiData.permissionList.forEach((item, index) => {
          this.$refs[`ref${index}`][0].getCheckedNodes().forEach(citem => {
            this.form.permission.push(citem.id)
          })
        })
        // 数组去重
        this.form.permission = [...new Set([...this.form.permission, ...this.form.permission])].sort()
        this.$refs['addForm'].validate(valid => {
          if (valid) {
            this.$store.commit('setSpinShow', true)
            const opt = { ...this.form }
            if (this.diyDom.isEdit) {
              apiRole
                .apiRoleEdit(this.diyData.id, opt)
                .then(res => {
                  this.$Message.success('编辑角色成功')
                  this.getDetail(this.diyData.id)
                })
                .finally(() => this.$store.commit('setSpinShow', false))
            } else {
              apiRole
                .apiRoleAdd(opt)
                .then(res => {
                  this.$Message.success('新增角色成功')
                  this.getPermission()
                })
                .finally(() => this.$store.commit('setSpinShow', false))
            }
          }
        })
      },
    },
    mounted() {
      this.getPermission()
    },
  }
</script>

<style scoped lang="less">
  .role-manage {
    display: flex;
    justify-content: left;
    .role-list {
      width: 250px;
    }
    .form {
      flex: 1;
    }
    .permission-wrap {
      padding: 10px 20px;
      border: 1px solid #ededed;
      .permission-content {
        display: flex;
        .item {
          width: 25%;
        }
      }
    }
    .ivu-menu-item-active {
      background-color: #5cadff!important;
    }
    .ivu-menu-item:hover {
      background-color: #5cadff!important;
    }
  }
</style>
